import axios from 'axios'
import moment from 'moment'
import { jwtDecode } from "jwt-decode"
export default class accessToken {
    private access_token = null
    private expires_at = null

    public async getAccessToken():Promise<any>{

        this.access_token = localStorage.getItem("access_token");

        if (this.access_token) {
            //console.log("Token recuperado ---------------")
            const decoded = jwtDecode(this.access_token)
            this.expires_at = decoded.exp
        }

        //console.log('expires_at: ', this.expires_at)
        //console.log(moment(moment.unix(this.expires_at)).isAfter(new Date))
        //console.log("-----------------------------------")

        if (moment(moment.unix(this.expires_at)).isAfter(new Date))
        {
            //console.log('usa token vigente:', this.access_token)              
            return( this.access_token )                
        }
        else
        {
            //console.log('obtiene nuevo token')
            const data: any = await this.getToken()

            if (data.access_token) {
                localStorage.setItem("access_token", data.access_token);
                this.access_token = data.access_token
                //console.log("Token guardado exitosamente.");
            }

            return this.access_token
        }
    }

    private async getToken() {
        try
        {
            const api = process.env.VUE_APP_IDENTITY + 'connect/token'
            const config = {
                headers: { "Content-Type": "application/x-www-form-urlencoded" }
            }
            const params = {
                client_id: process.env.VUE_APP_CLIENT_ID,
                client_secret: process.env.VUE_APP_CLIENT_PW,
                grant_type: "client_credentials",
                scope: "sie_api_difusion"
            }
            const result = await axios.post(api, params, config)

            return result.data; 
        }
        catch (error)
        {
            console.error(error)
        }
    }

}